import * as React from "react";
import { SVGProps } from "react";
const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15 5c5.523 0 10 4.477 10 10a9.957 9.957 0 0 1-2.108 6.142l5.074 5.073a1 1 0 0 1-1.32 1.498l-.094-.084-5.04-5.04A9.96 9.96 0 0 1 15 25C9.477 25 5 20.523 5 15S9.477 5 15 5Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSearch;
